export default "__VITE_ASSET__BWSn9dnz__"